
import React from 'react';
import { usePhoneReveal } from '@/hooks/usePhoneReveal';
import PhoneDisplay from '@/components/phone/PhoneDisplay';
import LoginRequiredDialog from '@/components/dialogs/LoginRequiredDialog';
import PhoneVerificationDialog from '@/components/dialogs/PhoneVerificationDialog';
import ProfileIncompleteDialog from '@/components/dialogs/ProfileIncompleteDialog';
import ConsentDialog from '@/components/dialogs/ConsentDialog';

interface PhoneRevealButtonProps {
  professionalName: string;
  professionalId: string;
  profession?: string;
  onBeforeReveal?: () => boolean;
  autoReveal?: boolean;
}

const PhoneRevealButton: React.FC<PhoneRevealButtonProps> = ({
  professionalName,
  professionalId,
  profession = "",
  onBeforeReveal,
  autoReveal = false
}) => {
  const {
    isRevealed,
    revealedPhoneNumber,
    isLoading,
    isDialogOpen,
    showPhoneRequiredDialog,
    showProfileIncompleteDialog,
    showConsentDialog,
    setIsDialogOpen,
    setShowPhoneRequiredDialog,
    setShowProfileIncompleteDialog,
    setShowConsentDialog,
    handleReveal,
    handleGoToLogin,
    handleGoToProfile,
    handleConsentApproved,
    handleVerificationComplete,
    user,
    profile
  } = usePhoneReveal({
    professionalName,
    professionalId,
    profession,
    onBeforeReveal,
    autoReveal
  });

  return (
    <>
      <PhoneDisplay
        phoneNumber={revealedPhoneNumber}
        isRevealed={isRevealed}
        autoReveal={autoReveal}
        isUserLoggedIn={!!user}
        isLoading={isLoading}
        onReveal={handleReveal}
      />
      
      <LoginRequiredDialog
        isOpen={isDialogOpen}
        onOpenChange={setIsDialogOpen}
        onGoToLogin={handleGoToLogin}
      />
      
      {user && (
        <PhoneVerificationDialog
          isOpen={showPhoneRequiredDialog}
          onOpenChange={setShowPhoneRequiredDialog}
          userPhone={user.user_metadata?.phone || ''}
          onVerified={handleVerificationComplete}
        />
      )}
      
      <ProfileIncompleteDialog
        isOpen={showProfileIncompleteDialog}
        onOpenChange={setShowProfileIncompleteDialog}
        onGoToProfile={handleGoToProfile}
      />
      
      <ConsentDialog
        isOpen={showConsentDialog}
        onOpenChange={setShowConsentDialog}
        onApprove={handleConsentApproved}
        professionalName={professionalName}
      />
    </>
  );
};

export default PhoneRevealButton;
